<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    Switch {{ 'Organisation' | ize }}
  </h4>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('exit')"
  ></button>
</div>

<div class="modal-body" [class.min-height]="showSearch">
  @if (filteredOrganisations$ | async; as filteredOrganisations) {
    @if (hasOtherOrganisations) {
      @if (showSearch) {
        <nav>
          <div class="input-group mb-2">
            <div class="input-group-text">
              <i-lucide name="search"></i-lucide>
            </div>
            <input
              type="search"
              class="form-control"
              autocomplete="off"
              [(ngModel)]="search"
            />
          </div>
        </nav>
      }

      <p>Choose an {{ 'organisation' | ize }} to switch to:</p>

      @for (org of filteredOrganisations; track org) {
        <div
          class="card border p-4 d-flex flex-row align-items-center"
          (click)="onSwitchOrganisation(org)"
        >
          <div class="d-flex flex-grow-1 flex-column pe-2 overflow-hidden">
            <h5 class="text-primary mb-0">
              {{ org.name }}
            </h5>
            @if (org.description?.length) {
              <p class="mb-0">
                {{ org.description }}
              </p>
            }
          </div>
          <div>
            <button class="btn btn-primary" type="button">Switch</button>
          </div>
        </div>
      }
    }

    @if (!hasOtherOrganisations) {
      <p>You don't have access to any other {{ 'organisations' | ize }}.</p>
    }
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline" (click)="modal.dismiss()">
    Cancel
  </button>
  <button
    class="btn btn-outline"
    type="button"
    (click)="onCreateOrganisation()"
  >
    <i-lucide name="plus"></i-lucide>
    Create new {{ 'organisation' | ize }}
  </button>
</div>
